import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

const FAQ = () => {
  const data = useStaticQuery(graphql`
    query FAQQuery {
      allFaqJson {
        edges {
          node {
            question
            answer
          }
        }
      }
    }
  `);

  const faqs = data.allFaqJson.edges.map(({ node }) => node);

  return (
    <section className="faq-section" aria-label="常见问题">
      <div className="index-container">
        <h2 className="faq-title" data-en="FAQ">常见问题</h2>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <article key={index} className="faq-item">
              <h3 className="faq-question">{faq.question}</h3>
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;